import { render, staticRenderFns } from "./EmptySelectedChat.vue?vue&type=template&id=3a775682&scoped=true&"
import script from "./EmptySelectedChat.vue?vue&type=script&lang=js&"
export * from "./EmptySelectedChat.vue?vue&type=script&lang=js&"
import style0 from "./EmptySelectedChat.vue?vue&type=style&index=0&id=3a775682&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a775682",
  null
  
)

export default component.exports